// extracted by mini-css-extract-plugin
module.exports = {"igv-alert-popup":"IgvAlertPopup_igv-alert-popup__3nGXX"};